import { z } from 'zod'

export const modalidadeFormSchema = z.object({
  idcampeonato: z.number({ required_error: 'Campeonato obrigatorio' }).int().positive(),
  grupo: z.enum(['IPSC', 'Silhueta', 'Precisao']),
  nome: z.string().min(1, 'Nome obrigatorio').max(120),
  divisao: z.string().max(120).optional().or(z.literal('')).transform(v => v || null),
  numero_alvo_serie: z.number().int().positive().optional().nullable().or(
    z.string().transform(v => (v ? parseInt(v, 10) : null))
  ),
  qtd_municao: z.number().int().positive().optional().nullable().or(
    z.string().transform(v => (v ? parseInt(v, 10) : null))
  ),
  permite_reinscricao: z.boolean().default(false),
  max_reinscricao: z.number().int().min(0).default(0),
  calcula_ranking: z.boolean().default(true),
  valor_x: z.number().int().min(0).nullable().optional().default(0),
  power_factor: z.enum(['major', 'minor']).optional().nullable(),
})

export type ModalidadeFormData = z.infer<typeof modalidadeFormSchema>
